(() => {
  if (window.bfdOnSaleFlashStarted) return;
  window.bfdOnSaleFlashStarted = true;
  let scheduled = false;
  const originals = new WeakMap();
  const setText = (node, text) => { if (node.textContent !== text) node.textContent = text; };
  const remember = node => {
    let state = originals.get(node);
    if (!state || node.textContent !== state.written) {
      state = { original: node.textContent, written: node.textContent };
      originals.set(node, state);
    }
    return state;
  };
  const render = () => {
    scheduled = false;
    const container = document.getElementById('ProductGridContainer');
    const dataNode = container?.querySelector('[data-bfd-on-sale-data]');
    let data = null;
    try { if (dataNode) data = JSON.parse(dataNode.textContent); } catch {}
    const active = !!data && document.querySelector('.bfd-sale-announcement')?.hidden === false;
    const priority = container?.querySelector('[data-bfd-on-sale-flash]');
    const ids = new Set(active && data.selected ? data.ids : []);
    container?.querySelectorAll('#product-grid [data-bfd-native-product]').forEach(node => {
      const duplicate = ids.has(node.dataset.bfdNativeProduct);
      if (duplicate && !node.dataset.bfdDuplicate) { node.dataset.bfdDuplicate = 'true'; node.dataset.bfdWasHidden = String(node.hidden); }
      if (duplicate && !node.hidden) node.hidden = true;
      if (!duplicate && node.dataset.bfdDuplicate) {
        const hidden = node.dataset.bfdWasHidden === 'true';
        if (node.hidden !== hidden) node.hidden = hidden;
        delete node.dataset.bfdDuplicate; delete node.dataset.bfdWasHidden;
      }
    });
    if (priority && priority.hidden !== !active) priority.hidden = !active;
    for (const node of document.querySelectorAll('#ProductCount,#ProductCountDesktop')) {
      const state = remember(node);
      const text = active && data.selected ? `${data.nativeCount + data.addedCount} products` : state.original;
      setText(node,text); state.written = text;
    }
    for (const input of document.querySelectorAll('input[name="filter.p.m.custom.product_type"][value="On Sale"]')) {
      const label = input.labels?.[0];
      if (!label) continue;
      for (const node of label.querySelectorAll('.facet-checkbox__text,.visually-hidden')) {
        const state = remember(node);
        const count = Number(state.original.match(/\((\d+)/)?.[1]);
        const text = active && Number.isFinite(count) ? state.original.replace(/\(\d+([\s\S]*?)\)/,`(${count + data.filterAddedCount}$1)`) : state.original;
        setText(node,text); state.written = text;
      }
    }
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(render); } };
  document.addEventListener('bfd:sale-state',schedule);
  new MutationObserver(records => { if (records.some(r=>r.addedNodes.length)) schedule(); }).observe(document.body,{childList:true,subtree:true});
  schedule();
})();
